<!-- 
  新建 联系人特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 地址 -->
    <v-address
      @change="addressSave"
      v-if="item.attr === 'address'"
      :attrValue="form.address">
    </v-address>
    <!-- 客户电话 -->
    <v-phone
      v-if="item.attr === 'phone'"
      @numChange="phoneSave"
      :attrValue.sync="form.phone">
    </v-phone>
    <!-- 关联客户 -->
    <template v-if="item.attr === 'customerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        >
      </associated-field>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import vAddress from '../address'
import associatedField from '../associated-field'
import vPhone from '../phone'

export default {
  props: ['item', 'form'],
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    addressSave (arr) {
      if (this.item.required && !arr.address.trim()) {
        this.$set(this.form, 'address', '')
      } else {
        this.$set(this.form, 'address', arr)
      }
      this.setAttr('address')
    },
    phoneSave (arr) {
      Vue.set(this.form, 'phone', arr)
    },
    addNew (arr) {
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    }
  },
  components: {
    vAddress,
    associatedField,
    vPhone
  }
}
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// index.vue?578e160f